import { collection, addDoc, query, where, orderBy, onSnapshot, updateDoc, doc, writeBatch, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import type { Notification, NotificationType, NotificationData } from '../types/notification';

export const subscribeToNotifications = (
  userId: string,
  callback: (notifications: Notification[]) => void
) => {
  const q = query(
    collection(db, `users/${userId}/notifications`),
    orderBy('createdAt', 'desc')
  );

  return onSnapshot(q, (snapshot) => {
    const notifications = snapshot.docs.map(doc => ({
      ...doc.data(),
      id: doc.id,
      createdAt: doc.data().createdAt.toDate()
    })) as Notification[];
    callback(notifications);
  });
};

export const createNotification = async (
  userId: string,
  type: NotificationType,
  title: string,
  message: string,
  data?: NotificationData
) => {
  const notification: Omit<Notification, 'id'> = {
    userId,
    type,
    title,
    message,
    data,
    read: false,
    createdAt: new Date()
  };

  await addDoc(collection(db, `users/${userId}/notifications`), notification);
};

export const markNotificationAsRead = async (
  userId: string,
  notificationId: string
) => {
  const notificationRef = doc(db, `users/${userId}/notifications/${notificationId}`);
  await updateDoc(notificationRef, { read: true });
};

export const markAllNotificationsAsRead = async (userId: string) => {
  const q = query(
    collection(db, `users/${userId}/notifications`),
    where('read', '==', false)
  );
  
  const snapshot = await getDocs(q);
  const batch = writeBatch(db);
  
  snapshot.docs.forEach(doc => {
    batch.update(doc.ref, { read: true });
  });
  
  await batch.commit();
}; 